/**
 * Whether a task opened by id (e.g. from an email link) is gone. A deleted task is usually only
 * soft-deleted (`trashed`, see deleteTasks), so the `task` query still returns it. A hard-deleted
 * or purged task makes the query fail with NOT_FOUND.
 */
export function isTaskDeleted(task?: { trashed?: boolean | null } | null, error?: any): boolean {
  if (task?.trashed) return true

  return (error?.graphQLErrors ?? []).some((graphQLError: any) => graphQLError?.extensions?.code === 'NOT_FOUND')
}
